module.exports = __webpack_public_path__ + "img/pimples.6896408a.svg";